import React from 'react';
import { UpdateSummary } from '../../../../contracting-reports/diff-report/diffing/section-updateSummary';

const EditLog = props => {
  const { summaryByPage } = props;
  return (
    <div>
      {
        (summaryByPage || []).length ? summaryByPage.map(({ header, pageSections }, index) => {
          return (
            <div key={header} style={{ marginTop: index ? '8px' : '0' }}>
              <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {header}
              </div>
              <div>
                {
                  pageSections.map(({ label, updateSummary = [] }) => {
                    return (
                      <div
                        key={label}
                      >
                          <span>
                            {label}
                            {
                              Boolean(updateSummary.length) && (
                                <UpdateSummary
                                  updateSummary={updateSummary}
                                />
                              )
                            }
                          </span>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          );
        }) : <span>You haven't made any changes yet.</span>
      }
    </div>
  );
};

export default EditLog;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/change-log/edit-log.js